import React from 'react'
import './imageview.css';

interface Props {
    src : string;
}

export class ImageView extends React.Component<Props> {

    render() {
        return (
            <div className="imageviewparent">
                <img className="imageview" src={ this.props.src } alt={ this.props.src } />
            </div>
        );
    }
}

